// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contrastBtn[data-v-15325032]{color:#fff;line-height:24px;background-color:#879dc9;border-radius:6px;width:35px;height:24px;padding:0 5px;margin-right:5px}", ""]);
// Exports
module.exports = exports;
